import { useQuery } from "@tanstack/react-query";
import { getSesseion } from "../../openapi/api-client";

export const useSSHSessionWithErrorHandling = (sessionId: string) => {
  return useQuery({
    queryKey: ["sessionId", { sessionId }],
    enabled: !!sessionId, // Only run query if sessionId exists
    retry: 1, // Only retry once
    queryFn: async () => {
      const response = await getSesseion({
        path: { sessionId },
      });

      // Handle 404 specifically
      if (response.error && response.response.status === 404) {
        throw new Error("SESSION_NOT_FOUND");
      }

      if (!response.data) {
        throw new Error(
          `Error fetching session: ${response.error.message || "Unknown error"}`,
        );
      }

      return response.data;
    },
  });
};
